/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Popover } from '@one-thd/sui-atomic-components';
import { links, pbSpendSummary } from '../../../constants';
import { getImageURL } from '../../../utils/GeneralUtil';

export const ToolTipMessage = () => {
  return (
    <div className="toolTipMessage">
      <p>{pbSpendSummary.spendIncludesLoyalty}&nbsp;</p>
      <br />
      <p>{pbSpendSummary.savingIncludes}</p>
      <br />
      <p>
        {pbSpendSummary.fullDetails}&nbsp;
        <a
          className="u__default-link"
          target="_blank"
          href={links.faqTermsAndConditions}
          rel="noreferrer"
        >
          {links.termsAndConditionsTitle}
        </a>
      </p>
    </div>
  );
};

export const SpendSummaryTooltip = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMouseOver = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? 'simple-popover' : undefined;

  return (
    <span className="sui-pl-2">
      {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
      <div onMouseOver={handleMouseOver} onFocus={handleMouseOver}>
        <img
          src={getImageURL('ProTiers/icon-info.svg')}
          alt="spend-summary-tooltip-icon"
          width="16px"
          height="16px"
        />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        placement="bottom"
      >
        <ToolTipMessage />
      </Popover>
    </span>
  );
};
